import { FETCH_BULLETIN, RESET_BULLETIN } from './constants'

const initialState = {
  isFetching: true,
  page: 1,
  messages: [], 
  totalCount: 0,
}

export default function topicsReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_BULLETIN: {
      return {
        ...initialState
      }
    }
    case FETCH_BULLETIN.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case FETCH_BULLETIN.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        messages: [...state.messages, ...action.payload.messages],
        totalCount: action.payload.totalCount,
        page: state.page + 1,
      };
    }
    default: {
      return state
    }
  }
}
